import { call, takeEvery, put } from "redux-saga/effects";
import {
  deleteDriverAction,
  driverEditAction,
  editDriverAction,
  searchDriverAction,
  getAllDriversAction,
  registerDriverAction,
  resetPasswordAction,
} from "../../api/driver/driverAction";
import { toast } from "react-toastify";
import { setAllDrivers, setSearchDriver, setLoading } from "../../redux/driver/driver-slice";

export function* registerDriverSaga(actions) {
  try {
    const response = yield call(registerDriverAction, actions.payload);
    if (response.status === 200) {
      toast.success("Driver registered successfully");
      yield put({
        type: "GET_ALL_DRIVERS",
        payload: {
          token: actions.payload.token,
        },
      });
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.msg || "Something went wrong");
  }
}

function* deleteDriverSaga(actions) {
  try {
    const response = yield call(deleteDriverAction, actions.payload);
    if (response.status === 200) {
      toast.success("Driver deleted successfully");
      yield put({
        type: "GET_ALL_DRIVERS",
        payload: {
          token: actions.payload.token,
        },
      });
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.msg || "Something went wrong");
  }
}

export function* getAllDriversSaga(actions) {
  try {
    const response = yield call(getAllDriversAction, actions.payload);
    if (response.status === 200) {
      yield put(
        setAllDrivers({
          allDrivers: response.data.drivers,
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

function* driverResetPasswordSaga(actions) {
  try {
    const response = yield call(resetPasswordAction, actions.payload);
    if (response.status === 200) {
      toast.success("Password reset successfully");
    }
  } catch (error) {
    console.log(error);
  }
}

function* editDriverSaga(actions) {
  try {
    const response = yield call(editDriverAction, actions.payload);
    if (response.status === 200) {
      toast.success("Driver edited successfully");
    }
  } catch (error) {
    console.log(error);
  }
}

function* searchDriverSaga(actions) {
  try {
    yield put(setLoading({isLoading:true}));
    const response = yield call(searchDriverAction, actions.payload);
    if (response.status === 200) {
      console.log("searchDriverSaga", response.data)
      yield put(setSearchDriver({searchDriver:response?.data?.data}))
      yield put(setLoading({isLoading:false}))
      console.log("setLoading==============>", setLoading)
    }
  } catch (error) {
    console.log(error);
  } finally {
    yield put(setLoading(false))
  }
}

// function* searchLoadingSaga(actions) {
//   try {
//     yield put(setLoading(true));
//   } finally {
//     yield put(setLoading(false));
//   }
// }

export function* watchDriverAsync() {
  yield takeEvery("REGISTER_DRIVER", registerDriverSaga);
  yield takeEvery("GET_ALL_DRIVERS", getAllDriversSaga);
  yield takeEvery("DRIVER_RESET_PASSWORD", driverResetPasswordSaga);
  yield takeEvery("DELETE_DRIVER", deleteDriverSaga);
  yield takeEvery("EDIT_DRIVER", editDriverSaga);
  yield takeEvery("SEARCH_DRIVER", searchDriverSaga);
  // yield takeEvery("SEARCH_LOADING", searchLoadingSaga)
}
